import { DisplayTarget } from "../enums/DisplayTarget";
import { FactoryComponents } from "../enums/FactoryComponents";

export class DashboardWidgetEvent
{
    id: any;
    displayTarget: DisplayTarget;
    factoryComponent: FactoryComponents;
}
